import useHeader from './header';

export default function useUser({ store, router }) {
  const { getHeader } = useHeader({ router, store });

  const sendUserSignUpEvent = () => store.$apiBFF.sendHeaderPersEvent({ type: 'user-sign-up', header: getHeader() });

  const sendUserSignInClickBtnEvent = () => store.$apiBFF.sendHeaderPersEvent({ type: 'user-send-auth-data', header: getHeader() });

  const sendUserLogInEvent = () => store.$apiBFF.sendHeaderPersEvent({ type: 'user-log-in', header: getHeader() });

  const sendUserLogOutEvent = () => store.$apiBFF.sendHeaderPersEvent({ type: 'user-log-out', header: getHeader() });

  return {
    sendUserSignUpEvent,
    sendUserSignInClickBtnEvent,
    sendUserLogInEvent,
    sendUserLogOutEvent,
  };
}
